import PropTypes from 'prop-types'
import React from 'react'

import ButtonRounded from 'components/ButtonRounded'

const WebPaymentBtn = ({ title, ...props }) => {
  return (
    <ButtonRounded
      as="button"
      bgClassName="bg--black"
      iconColor="transparent"
      wrapperProps={props}
    >
      {title}
    </ButtonRounded>
  )
}

WebPaymentBtn.propTypes = {
  title: PropTypes.string.isRequired,
}

export default WebPaymentBtn
